module.exports = __webpack_public_path__ + "static/img/pic3.e30de89.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icon/pic3.jpg
// module id = 50lV
// module chunks = 1